import React from "react";
import FileDownloader, { FileDownloaderProps } from "@/components/FileDownloader/FileDownloader";
import { getBulkLogisticsPackaging } from "@/api/template";

function DownloadLogisticsPackagingTemplate(props: Partial<FileDownloaderProps>) {
  return (
    <FileDownloader
      fileOutputName={`template-logistics-packaging.xlsx`}
      fileUrlFn={getBulkLogisticsPackaging}
      {...props}
    />
  );
}

export default DownloadLogisticsPackagingTemplate;
